import { create } from "zustand";
import { devtools } from "zustand/middleware";

import { TAlarmPayload } from "./Notifications.types";

type TNotificationState = {
  seenAlarms: TAlarmPayload[];
  pendingAlarms: TAlarmPayload[];
};

type TNotificationStore = TNotificationState & {
  pushPendingAlarms: (newAlarm: TAlarmPayload) => void;
  movePendingToSeen: () => void;
  resetAlarms: () => void;
};

const initialState: TNotificationState = {
  seenAlarms: [],
  pendingAlarms: [],
};

export const useNotificationStore = create<TNotificationStore>()(
  devtools((set, get) => ({
    ...initialState,
    pushPendingAlarms: (newAlarm: TAlarmPayload) => {
      const { pendingAlarms } = get();
      set(
        {
          pendingAlarms: [...pendingAlarms, newAlarm],
        },
      );
    },
    movePendingToSeen: () => {
      const { pendingAlarms, seenAlarms } = get();
      set({
        seenAlarms: [...pendingAlarms, ...seenAlarms],
        pendingAlarms: [],
      });
    },
    resetAlarms: () => {
      const { seenAlarms, pendingAlarms } = get();
      if (seenAlarms.length > 0 || pendingAlarms.length > 0) {
        set({
          seenAlarms: [],
          pendingAlarms: [],
        });
      }
    },
  })),
);
